const types = {
    addPrograms: 'add - programs',
}

const initialPrograms = {
    programs: []
}

const programsReducer = (state, action) => {
    switch(action?.type){
        case types?.addPrograms:
            return {
                programs: action?.payload?.slice()
            }
        default:
            return state;
    }
}

export { initialPrograms, types }
export default programsReducer;